module.exports = __webpack_public_path__ + "pics.3074892c.png";